const config = {
  // 默认是否是宽屏模式
  wideScreen: true,
  // 是否是集成模式（纯净模式，无顶部、侧边菜单栏），优先级高于宽屏模式
  integrationScreen: false,
};

export default config;
